
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-blue-600 to-blue-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/1af09471f2b5cbef722af36c4531530c/c169a9dfe09670aa2aee641d46da293d.png" 
              alt="スリホ" 
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-blue-100 leading-relaxed">
              業界シェアNo.1のプリンターレンタルサービス。定額制で印刷し放題、充実のサポート体制でお客様のビジネスをサポートします。
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">サービス</h4>
            <ul className="space-y-3">
              <li><a href="#features" className="text-blue-100 hover:text-white transition-colors">サービス特徴</a></li>
              <li><a href="#benefits" className="text-blue-100 hover:text-white transition-colors">導入メリット</a></li>
              <li><a href="#pricing" className="text-blue-100 hover:text-white transition-colors">料金プラン</a></li>
              <li><a href="#contact" className="text-blue-100 hover:text-white transition-colors">お問い合わせ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">機種情報</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-blue-100 hover:text-white transition-colors">インクジェットタイプ</a></li>
              <li><a href="#" className="text-blue-100 hover:text-white transition-colors">レーザータイプ</a></li>
              <li><a href="#" className="text-blue-100 hover:text-white transition-colors">複合機</a></li>
              <li><a href="#" className="text-blue-100 hover:text-white transition-colors">大型プリンター</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">お問い合わせ</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span className="text-blue-100">090-3716-1918</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span className="text-blue-100">info@it-support.club</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-user-line"></i>
                <span className="text-blue-100">担当者: 大久保博</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span className="text-blue-100">平日 9:00〜18:00</span>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-blue-500 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-blue-100 text-sm">
              &copy; 2025 スリホ. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-blue-100 hover:text-white transition-colors">プライバシーポリシー</a>
              <a href="#" className="text-blue-100 hover:text-white transition-colors">利用規約</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-blue-100 hover:text-white transition-colors">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
